import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getCustomMessages,
    getMessagesParameter,
    MessageCollectionModel,
} from "@tKgpco/Services/LoadMessageCollection";

type HandlerType = ApiHandler<getMessagesParameter, MessageCollectionModel[]>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getCustomMessages(props.apiParameter);
};

export const DispatchCompleteLoadDiscrepancyMessages: HandlerType = props => {
    props.dispatch({
        type: "Custom/DiscrepancyHistory/CompleteLoadDiscrepancyMessages",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadDiscrepancyMessages];

const loadDiscrepancyMessages = createHandlerChainRunner(chain, "loadDiscrepancyMessages");
export default loadDiscrepancyMessages;
